// Shelf layout is a wrapper only. Product markup comes from global-productCard.liquid.
const productShelfMarkup = (index, product) => {
  const slide = document.createElement("div");
  slide.className = "swiper-slide mr-3 last-of-type:mr-0 !w-40 xl:!w-56";
  slide.dataset.tags = product.tags.map((tag) => tag.toLowerCase()).join(",");
  slide.dataset.price = product.variants[0].price;
  slide.dataset.index = index;
  slide.innerHTML = product.card;
  return slide.outerHTML;
};

const productArticleMarkup = (product, requestedVariantId, colour) => {
  const requiresSignature = product.tags.includes("Requires Signature");
  const dangerousGoods = product.tags.includes("Dangerous Goods");

  let productImage = `${product.featured_image}?width=200`;
  let productPrice = product.price;
  let productCompareAtPrice = product.compare_at_price;
  let productUrl = product.url;
  let variantTitle = "";
  let variantId = product.variants[0].id;

  if (requestedVariantId) {
    const variant = product.variants.find((v) => v.id == requestedVariantId);
    if (variant) {
      productImage =
        `${variant.featured_image.src}?width=200` || product.featured_image;
      productPrice = variant.price;
      productCompareAtPrice =
        variant.compare_at_price || product.compare_at_price;
      productUrl = `${product.url}?variant=${variant.id}`;
      variantTitle = variant.title;
      variantId = requestedVariantId;
    }
  }

  return `
          <div class="product not-prose relative flex flex-row gap-4 w-full mb-8 p-2 rounded-lg bg-white sm:p-3" style="background: ${colour}1a;" data-variant-id="${variantId}" data-limoniapps-discountninja-product-handle="${
            product.handle
          }" data-limoniapps-discountninja-product-collections="${
            product.vendor
          }" data-limoniapps-discountninja-product-available="${
            product.variants[0].available
          }" data-limoniapps-discountninja-product-price="${
            product.variants[0].price * 100
          }">
            <a href="${
              product.url
            }" class="flex w-40 p-3 aspect-square bg-white rounded-md sm:w-56">
              <img class="m-auto h-full object-contain" src="${productImage}" alt="${
                product.title
              }" width="104" height="104" loading="lazy">
            </a>
            <div class="flex flex-col w-full py-2 pr-2">
              <span class="w-max text-xs uppercase tracking-wide font-bold sm:text-base" style="color: ${colour};">
                ${product.vendor}
              </span>
              <a href="${
                product.url
              }" class="font-semibold text-base sm:text-xl">${product.title}</a>
              ${
                variantTitle
                  ? `<p class="text-sm sm:text-base" style="color: ${colour};">${variantTitle}</p>`
                  : ""
              }
              <div
                class="prose-sm prose-p:text-sm h-16 overflow-hidden mt-2"
                style="mask-image: linear-gradient(to top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 1)); -webkit-mask-image: linear-gradient(to top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 1));"
              >
                ${product.description}
              </div>
              <div class="flex flex-row items-end gap-2 justify-between mt-auto pt-4 lg:pt-8">
                <span class="limoniapps-discountninja-productprice price font-bold text-lg sm:text-xl lg:text-2xl">
                  ${formatPrice(productPrice)}
                  ${
                    productPrice < productCompareAtPrice
                      ? `<span class="text-gray-500 font-normal line-through text-sm">${formatPrice(
                          productCompareAtPrice,
                        )}</span>`
                      : ``
                  }
                </span>

                <div class="w-full flex flex-row items-center gap-1 justify-end max-w-32">
                  ${
                    product.variants[0].available
                      ? `<button type="button" aria-label="Add ${product.title} to bag" class="add-to-cart font-medium text-xs text-white rounded-full h-[36px] py-2 px-3 w-full 2xl:h-[40px] 2xl:text-sm" data-variant-id="${variantId}" data-dg="${dangerousGoods}" data-rs="${requiresSignature}" style="background: ${colour};">Add to Bag</button>
                      <div
                        class="quantity-container h-[36px] gap-2 w-full hidden items-center 2xl:h-[40px] 2xl:text-sm"
                      >
                      <div class="flex flex-row justify-between w-full h-full rounded-full" style="background: ${colour}1a;">
                        <button
                          class="decrease-icon font-medium block p-2 rounded-tl-full rounded-bl-full cursor-pointer 2xl:px-3"
                          aria-label="Decrease ${product.title} quantity by 1"
                          style="background: ${colour};"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="2"
                            stroke="currentColor"
                            class="w-4 h-4 text-white"
                          >
                            <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 12h-15"></path>
                          </svg></button
                        ><span class="item-quantity grid place-items-center text-sm font-semibold py-2 w-full text-center" style="background: ${colour}1a;">1</span
                        ><button
                          class="increase-icon font-medium block p-2 rounded-tr-full rounded-br-full cursor-pointer 2xl:px-3"
                          aria-label="Increase ${product.title} quantity by 1"
                          style="background: ${colour};"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="2"
                            stroke="currentColor"
                            class="w-4 h-4 text-white"
                          >
                            <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15"></path>
                          </svg>
                        </button>
                      </div>
                    </div>
                  `
                      : `
                      <button
                      type="button"
                      aria-label="Product is out of stock"
                      class="out-of-stock font-medium text-xs rounded-full h-[36px] py-2 px-3 w-full border border-allure-100 opacity-50 cursor-not-allowed 2xl:h-[40px] 2xl:text-sm"
                      style="background: ${colour}1a;"
                      disabled
                    >
                      Out of Stock
                    </button>`
                  }
                </div>
              </div>
            </div>
          </div>
        `;
};
